import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import RecordsSection from "@/components/RecordsSection";
import HeaderControls from "@/components/HeaderControls";
import { KATEGORIEN } from "@/lib/constants";
import { infoColumns, infoFields, infoDefault, uhaftColumns, uhaftFields, uhaftDefault, telefonColumns, telefonFields, telefonDefault, wichtigkeitRowClass } from "@/lib/entities";
import { FileText, AlertTriangle, Lock, CalendarRange, Clock, Bell, Phone } from "lucide-react";

const ICONS = { AlertTriangle, Lock, CalendarRange, Clock, Bell, Phone };
const ACCENT = {
  amber: "text-amber-400 border-amber-500/30 bg-amber-500/10",
  red: "text-red-400 border-red-500/30 bg-red-500/10",
  blue: "text-primary border-primary/30 bg-primary/10",
};

export default function Informationen() {
  const { user } = useAuth();
  const officer = user ? `${user.name}${user.dienstnummer ? ` (${user.dienstnummer})` : ""}` : "";

  return (
    <div>
      <PageHeader
        eyebrow="SADCR · Verwaltung"
        title="Allgemeine Informationen"
        description="Mitteilungen, Haft-Informationen und Reminder – alle Kategorien auf einen Blick."
        icon={FileText}
        action={<HeaderControls />}
      />
      <div className="p-8 grid grid-cols-1 xl:grid-cols-2 gap-x-8 gap-y-10">
        {KATEGORIEN.map((k) => {
          const Icon = ICONS[k.icon] || FileText;
          const isUhaft = k.value === "einzelhaft_uhaft";
          const isTelefon = k.value === "telefon_zellen";
          const cols = isTelefon ? telefonColumns : isUhaft ? uhaftColumns : infoColumns;
          const flds = isTelefon ? telefonFields : isUhaft ? uhaftFields : infoFields;
          const def = isTelefon
            ? telefonDefault(k.value)
            : isUhaft
            ? uhaftDefault(officer, k.value)
            : infoDefault(officer, k.value);
          return (
            <section key={k.value} className="space-y-3 scroll-mt-24" id={k.value}>
              <div className="flex items-center gap-2.5">
                <div className={`h-7 w-7 grid place-items-center rounded-sm border ${ACCENT[k.accent]}`}>
                  <Icon className="h-3.5 w-3.5" />
                </div>
                <h2 className="font-heading text-sm font-bold uppercase tracking-wide text-zinc-100">
                  {k.label}
                </h2>
              </div>
              <RecordsSection
                endpoint="/informationen"
                columns={cols}
                fields={flds}
                makeDefault={def}
                extraQuery={{ kategorie: k.value }}
                createLabel="Eintrag erstellen"
                emptyLabel={`Keine Einträge unter „${k.label}“`}
                testidPrefix={`info-${k.value}`}
                rowClass={wichtigkeitRowClass}
              />
            </section>
          );
        })}
      </div>
    </div>
  );
}
